import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["appId", "oAuthorAccountId", "providerKey", "registry", "children", "onComplete", "onCancel", "portalId", "appName", "oAuthScopes", "mcpParams", "config", "use", "size"];
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { defaultRegistry, useResolvedProvider } from './registry';
import { jsx as _jsx } from "react/jsx-runtime";
export const MigrationReconnectAccount = _ref => {
  let {
      appId,
      oAuthorAccountId,
      providerKey,
      registry = defaultRegistry,
      children,
      onComplete,
      onCancel,
      portalId,
      appName,
      oAuthScopes,
      mcpParams,
      config,
      use,
      size
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    components,
    isLoading
  } = useResolvedProvider(appId, providerKey, registry);
  if (isLoading) {
    return /*#__PURE__*/_jsx(LoadingButton, {
      use: use,
      size: size,
      disabled: true,
      loading: true,
      children: children
    });
  }
  if (!components) {
    console.error(providerKey ? `[MigrationReconnectAccount] No auth provider found for appId: ${appId} with providerKey: "${providerKey}"` : `[MigrationReconnectAccount] No auth provider found for appId: ${appId}`);
    return null;
  }
  const {
    Button
  } = components;
  return /*#__PURE__*/_jsx(Button, Object.assign({}, buttonProps, {
    use: use,
    size: size,
    appId: appId,
    oAuthorMigrationParams: {
      oAuthorAccountId
    },
    portalId: portalId,
    appName: appName,
    oAuthScopes: oAuthScopes,
    mcpParams: mcpParams,
    config: config,
    onComplete: onComplete,
    onCancel: onCancel,
    children: children
  }));
};
MigrationReconnectAccount.displayName = 'MigrationReconnectAccount';